/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { localDateRangeSchema } from './localDateRangeSchema';

export const availabilityRangeCreateRequestSchema = z.object({
  get dateRange() {
    return localDateRangeSchema;
  },
  endDate: z.iso.date().nullish(),
  fridayDuration: z.int().min(0).max(86400),
  mondayDuration: z.int().min(0).max(86400),
  name: z.string().min(0).max(255).nullish(),
  observanceRule: z.enum(['NONE', 'NEXT_WORKING_DAY']),
  priority: z.string().min(0).max(100).nullish(),
  saturdayDuration: z.int().min(0).max(86400),
  schemeId: z.int(),
  startDate: z.iso.date().nullish(),
  sundayDuration: z.int().min(0).max(86400),
  thursdayDuration: z.int().min(0).max(86400),
  tuesdayDuration: z.int().min(0).max(86400),
  type: z.enum(['HOLIDAY', 'BASE', 'RULE']),
  wednesdayDuration: z.int().min(0).max(86400),
});
